import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import StandardSearch from '../StandardSearch'

interface Props {
  sx?: SxProps
  search: string | null
  setSearch: (search: string | null) => void
}

const ExportTablesListHero = React.memo((props: Props) => {
  const { sx, search, setSearch } = props

  return (
    <Box
      sx={{
        ...sx
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          gap: 1,
          justifyContent: 'flex-end',
          mb: 1
        }}
      >
        <StandardSearch search={search} setSearch={setSearch} />
      </Box>
    </Box>
  )
})

ExportTablesListHero.displayName = 'ExportTablesListHero'

export default ExportTablesListHero
